export default __webpack_public_path__ + "static/media/6-2.3479a596.png";